import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useImperativeHandle, useRef } from 'react';
import './SelectBtn.scss';
import { SvgCaretDown, TertiaryBtn, isTouchDevice } from '../../index';
import { InputClearBtn } from '../input/InputClearBtn';
export const SelectBtn = forwardRef((props, ref) => {
    const btnRef = useRef(null);
    useImperativeHandle(ref, () => ({
        focus: () => {
            if (!isTouchDevice()) {
                btnRef.current?.focus();
            }
        },
    }));
    return (_jsxs("div", { className: 'sg-selectBtn', children: [_jsx("button", { className: 'sg-selectBtn--btn', ref: btnRef, type: 'button', name: props.name, disabled: props.isDisabled, onKeyDown: props.onKeyDown, onClick: props.onClick, "aria-invalid": props.isInvalid, "data-hovered": props.isHovered, "data-test-id": props.testId, title: props.children, children: props.children }), props.onClearBtnClick && !props.isDisabled && (_jsx(InputClearBtn, { onClick: props.onClearBtnClick, testId: props.testId && `${props.testId}-clearBtn` })), _jsx(TertiaryBtn, { icon: { element: _jsx(SvgCaretDown, {}) }, tabIndex: -1, onClick: props.onClick }), props.buttons] }));
});
//# sourceMappingURL=SelectBtn.js.map